import { useRef as r, useEffect as c } from "react";

function u(e) {
  var t = r(e);
  return c(function () {
    t.current = e;
  }, [e]), t;
}

export { u as useLatestValue };